import { render, staticRenderFns } from "./stock_balance_list.vue?vue&type=template&id=675da862&scoped=true"
import script from "./stock_balance_list.vue?vue&type=script&lang=js"
export * from "./stock_balance_list.vue?vue&type=script&lang=js"
import style0 from "./stock_balance_list.vue?vue&type=style&index=0&id=675da862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675da862",
  null
  
)

export default component.exports